module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MV - Maldives.cf5095d7.svg";